{
    "title": "Demonstration control",
    "subtitle": "Move the clock, save the state, and run a prepared scenario. Everything here works against the real database — nothing on this page is a mock-up.",
    "tabs": {
        "control": "Control",
        "scenarios": "Scenarios"
    },

    "clock": {
        "title": "Clock",
        "help": "Moves the platform's sense of \"now\" so an SLA breach, a nightly sweep or a scheduled report can be watched happening rather than described. It does not sign you out: idleness is measured on the real clock.",
        "simulated": "The platform believes it is",
        "real": "It really is",
        "travelling": "Travelling",
        "real_time": "Real time",
        "offset": "Offset",
        "offset_value_one": "{{count}} day ahead",
        "offset_value_other": "{{count}} days ahead",
        "offset_behind_one": "{{count}} day behind",
        "offset_behind_other": "{{count}} days behind",
        "offset_hours_one": "{{count}} hour ahead",
        "offset_hours_other": "{{count}} hours ahead",
        "forward_hours": "+{{count}} hours",
        "forward_days_one": "+{{count}} day",
        "forward_days_other": "+{{count}} days",
        "back_days_one": "−{{count}} day",
        "back_days_other": "−{{count}} days",
        "to_date": "Go to a date",
        "go": "Go",
        "reset": "Back to real time",
        "expires": "An offset lasts a day and then lapses by itself, so a demonstration cannot leave the next one in the future."
    },

    "data": {
        "title": "Data",
        "profile": "Seed profile",
        "profile_full": "Full — production-like volumes",
        "profile_test": "Test — small, for the suite",
        "counts": "What is loaded",
        "reset": "Rebuild the database",
        "reset_help": "Drops everything, re-runs the migrations and re-seeds. Deterministic: the same records come back with the same identifiers every time.",
        "reset_confirm_title": "Rebuild the database?",
        "reset_confirm_body": "Everything entered during this session is lost, including anything an evaluator has just typed. It takes about half a minute.",
        "reset_running": "Rebuilding…",
        "reset_done": "Rebuilt in {{seconds}} seconds.",
        "row_customers": "Customers",
        "row_complaints": "Complaints",
        "row_interactions": "Interactions",
        "row_queue_tickets": "Queue tickets",
        "row_cc_conversations": "Conversations",
        "row_survey_responses": "Survey responses",
        "row_daily_metrics": "Daily metrics",
        "row_users": "Users"
    },

    "snapshots": {
        "title": "Snapshots",
        "help": "A snapshot is the whole database, saved in a second. Take one before letting an evaluator try something destructive, and restore it when they have.",
        "name": "Snapshot name",
        "name_placeholder": "before-the-board-meeting",
        "take": "Take a snapshot",
        "restore": "Restore",
        "restore_confirm_title": "Restore “{{name}}”?",
        "restore_confirm_body": "The current database is replaced by the saved one and the clock goes back to real time. Anything done since the snapshot is lost.",
        "delete": "Delete",
        "delete_confirm_title": "Delete “{{name}}”?",
        "delete_confirm_body": "The saved copy is removed. The live database is untouched.",
        "empty": "No snapshots yet.",
        "taken": "Taken",
        "size": "Size",
        "unavailable": {
            "demo_mode_off": "Snapshots need demonstration mode.",
            "unsupported_driver": "Snapshots are a SQLite file copy. On PostgreSQL, use your own backup tooling — pg_dump needs client binaries and a role this application cannot assume it has.",
            "in_memory_database": "This installation has no database file to copy."
        }
    },

    "scenarios": {
        "title": "Prepared scenarios",
        "help": "Each one answers a question an evaluator is entitled to ask, in a few minutes, against seeded data.",
        "minutes": "{{count}} min",
        "steps_one": "{{count}} step",
        "steps_other": "{{count}} steps",
        "open": "Open",
        "run": "Do it for me",
        "not_ready": "The seeded data cannot support this scenario right now. Rebuild the database to restore it.",
        "step": "Step {{number}}"
    },

    "errors": {
        "name_required": "Give the snapshot a name."
    }
}
